<template>
  <div class="fragment">
    <div class="content-top-line content-top-line--with-bottom-line"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate([
          'express_allOrders',
          'express_allOrdersSub',
          'express_DHLSub',
          'express_fedexSub',
          'express_poshtaSub',
          'express_tntSub',
          'express_dhlPlSub',
        ])"></div>

      <div class="content-tabs content-tabs--separator"
           v-if="Object.keys($store.getters.getUserProfile).length > 0"
           v-bind:class="{'loading-tabs': $store.getters.getExpressLoading === true,}">
        <template v-for="(item, index) in navTabs">
          <div class="content-tabs__item"
               :key="index + loadUserRoleAndAuthorizedData"
               v-bind:class="{active: item.active}"
               v-if="checkUserFromSNGGroup(item) && checkDHLExpressUserFromGB(item.id) && checkUkrainianUserInTNT(item.id) && item.permissionVisible"
               @click="$emit('changeTab', item.name)"
          >
            <div class="content-tabs__ico">
              <template v-if="item.ico">
                <img :src="item.ico" alt="company-ico" :width="item.icoWidth">
              </template>
              <template v-else>
                {{ item.label }}
              </template>
            </div>
            <span class="content-tabs__item-small">
              {{ item.subLabel }}
            </span>
          </div>
        </template>
      </div>

      <div class="content-top-line-wrap">
        <ToggleFilterButton
            :count="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="$emit('toggleFilter')"
        />
      </div>
    </div>

    <div class="light-bg-block" style="flex-wrap: wrap;">
      <div class="btn-left-block">
        <DefaultCheckbox
            :label="$t('warehouseManagement_selectAll.localization_value.value')"
            @input="(val) => $emit('selectAll', val)"
        />
      </div>
      <div class="btn-right-block"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
          'common_AddNew',
          'express_labels',
        ])"></div>
        <div class="d-flex align-items-center"
             v-if="!isAdmin && _.has(getCurrentUserAlternativeContact, 'country_id')"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['express_AlternativeAddress',])"></div>
          <DefaultCheckbox
              :value="isUseAlternativeContact"
              :disabled="true"
          />
            {{$t('express_AlternativeAddress.localization_value.value')}}
          <LinkButton
              class="mr-3 ml-2"
              :type="'edit'"
              @click.native="isModalAddressEditingPopup = true"
          />
        </div>
        <span v-if="navTabs.all.active && !isLatvian">
          <MainButton class="btn-fit-content"
                      :value="$t('common_AddNew.localization_value.value')"
                      :ico="'ico'"
                      @click.native="showChooseExpressOrderPopup"
          >
            <template slot="ico">
              <PlusIconSVG class="btn-icon-plus"/>
            </template>
          </MainButton>
        </span>
<!--        && !navTabs[NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.name].active-->
        <router-link
            v-else-if="isDHLBtnCreate && getNewOrderLink"
            :to="getNewOrderLink">
          <MainButton class="btn-fit-content"
                      :value="$t('common_AddNew.localization_value.value')"
                      :ico="'ico'"
          >
            <template slot="ico">
              <PlusIconSVG class="btn-icon-plus"/>
            </template>
          </MainButton>
        </router-link>
        <router-link :to="$store.getters.GET_PATHS.expressLabels"
                     v-if="_.has(this.currentPermissions, PERMISSIONS.ORDER_EXPRESS_VIEW_BLOCKED_DOCS)"
                     class="ml-3"
        >
          <MainButton class="btn-fit-content"
                      :value="$t('express_labels.localization_value.value')"
          >
          </MainButton>
        </router-link>
        <!--        <router-link-->
        <!--                :to="$store.getters.GET_PATHS.expressOrderCreation + 'dhl'"-->
        <!--                v-if="navTabs[DHL_DELIVERY_SERVICE.name].active">-->
        <!--          <MainButton class="btn-fit-content"-->
        <!--                      :value="$t('shops_addNew.localization_value.value')"-->
        <!--                      :ico="'ico'"-->
        <!--                      @click.native="showChooseExpressOrderPopup"-->
        <!--          >-->
        <!--            <template slot="ico">-->
        <!--              <PlusIconSVG class="btn-icon-plus" />-->
        <!--            </template>-->
        <!--          </MainButton>-->
        <!--        </router-link>-->
        <!--        <router-link-->
        <!--                v-if="navTabs[FEDEX_DELIVERY_SERVICE.name].active"-->
        <!--                :to="$store.getters.GET_PATHS.expressOrderCreation + 'fedex'"-->
        <!--        >-->
        <!--          <MainButton class="btn-fit-content"-->
        <!--                      :value="$t('shops_addNew.localization_value.value')"-->
        <!--                      :ico="'ico'"-->
        <!--                      @click.native="showChooseExpressOrderPopup"-->
        <!--          >-->
        <!--            <template slot="ico">-->
        <!--              <PlusIconSVG class="btn-icon-plus" />-->
        <!--            </template>-->
        <!--          </MainButton>-->
        <!--        </router-link>-->
        <!--        <router-link-->
        <!--                v-if="navTabs[TNT_DELIVERY_SERVICE.name].active"-->
        <!--                :to="$store.getters.GET_PATHS.expressOrderCreation + 'tnt'"-->
        <!--        >-->
        <!--          <MainButton class="btn-fit-content"-->
        <!--                      :value="$t('shops_addNew.localization_value.value')"-->
        <!--                      :ico="'ico'"-->
        <!--                      @click.native="showChooseExpressOrderPopup"-->
        <!--          >-->
        <!--            <template slot="ico">-->
        <!--              <PlusIconSVG class="btn-icon-plus" />-->
        <!--            </template>-->
        <!--          </MainButton>-->
        <!--        </router-link>-->
      </div>
    </div>


    <ChooseExpressOrderPopup
        @close="closeChooseExpressOrderPopup"
        v-if="isModalChooseExpressOrderPopup"
        :dhl="checkCreateDHL()"
        :fedex="checkCreateFedex()"
        :tnt="checkCreateTNT()"
        :npg="checkCreatePoshta()"
        :ups="checkCreateUPS()"
        :dhlpl="checkCreateDHLPL()"
        :npi="checkCreateNPI()"
    />

    <AddressEditing
        @close="isModalAddressEditingPopup = false"
        @reloadPage="$emit('reloadPage')"
        v-if="isModalAddressEditingPopup"
    />

  </div>
</template>

<script>
import MainButton from "../../../../../../UI/buttons/MainButton/MainButton";
import ToggleFilterButton from "../../../../../../UI/buttons/ToggleFilterButton/ToggleFilterButton";
import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
import PlusIconSVG from '../../../../../../../../public/img/UI-group/plus-icon.svg?inline'
import ChooseExpressOrderPopup
  from "../../../../../../coreComponents/Popups/ChooseExpressOrder/ChooseExpressOrderPopup";
import {
  DHL_DELIVERY_SERVICE, DHLPL_DELIVERY_SERVICE, NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE,
  FEDEX_DELIVERY_SERVICE, NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE,
  TNT_DELIVERY_SERVICE, UPS_DELIVERY_SERVICE
} from "../../../../../../../staticData/staticVariables";
import LinkButton from "@/components/UI/buttons/LinkButton/LinkButton";
import AddressEditing from "@/components/modules/ProfileModule/popups/AddressEditing/AddressEditing";
import {expressCreatePopupMixin} from "@/mixins/expressMixins/expressCreatePopupMixin";


export default {
  name: "ExpressOrderTableUserHead",
  components: {
    LinkButton,
    MainButton,
    ToggleFilterButton,
    DefaultCheckbox,
    PlusIconSVG,
    ChooseExpressOrderPopup,
    AddressEditing,
  },

  mixins: [
    expressCreatePopupMixin,
  ],

  props: {
    showFilter: Boolean,
    countFilterParams: Number,
    navTabs: Object,
  },

  computed: {
    isOwnerPoland() {
      return this.isPolandByUserData(this.loadUserAuthorizedData.user?.owner_user_personal_contact?.country_group)
    },

    isNPIBtnCreate() {
      if (this.navTabs[NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE.name].active) {
        return true
      }
      return false
    },

    isDHLBtnCreate() {
      if(!this.navTabs[DHL_DELIVERY_SERVICE.name].active) {
        return true
      }
      if(this.loadUserAuthorizedData.user?.company_owner?.id) {
        if(this.isOwnerPoland) {
          return false
        }
        return true
      }

      if(this.isUserAlternativeContactPoland || this.isPoland) {
        return false
      }

      return  true
    },





    getNewOrderLink() {

      if (this.isLatvian) {
        return this.$store.getters.GET_PATHS.expressOrderCreation + 'fedex'
      }

      if (this.navTabs[DHL_DELIVERY_SERVICE.name].active) {
        return this.$store.getters.GET_PATHS.expressOrderCreation + 'dhl'
      }
      if (this.navTabs[FEDEX_DELIVERY_SERVICE.name].active) {
        return this.$store.getters.GET_PATHS.expressOrderCreation + 'fedex'
      }
      if (this.navTabs[DHLPL_DELIVERY_SERVICE.name].active) {
        return this.$store.getters.GET_PATHS.expressOrderCreation + 'dhlpl'
      }
      // if (this.navTabs[TNT_DELIVERY_SERVICE.name].active) {
      //   return this.$store.getters.GET_PATHS.expressOrderCreation + 'tnt'
      // }

      // if (this.navTabs[NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.name].active) {
      //   return this.$store.getters.GET_PATHS.expressOrderCreation + NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.name
      // }

      if (this.navTabs[UPS_DELIVERY_SERVICE.name].active) {
        return false
        // return this.$store.getters.GET_PATHS.expressOrderCreation + UPS_DELIVERY_SERVICE.name
      }

      if (this.navTabs[NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE.name].active) {
        return this.$store.getters.GET_PATHS.expressOrderCreation + NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE.name
      }

      return false
    },
  },

  data() {
    return {
      isModalChooseExpressOrderPopup: false,
      isModalAddressEditingPopup: false,
      DHL_DELIVERY_SERVICE: DHL_DELIVERY_SERVICE,
      DHLPL_DELIVERY_SERVICE: DHLPL_DELIVERY_SERVICE,
      FEDEX_DELIVERY_SERVICE: FEDEX_DELIVERY_SERVICE,
      TNT_DELIVERY_SERVICE: TNT_DELIVERY_SERVICE,
      NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE: NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE,
      UPS_DELIVERY_SERVICE: UPS_DELIVERY_SERVICE
    }
  },

  methods: {

    showChooseExpressOrderPopup() {
      this.isModalChooseExpressOrderPopup = true
    },

    closeChooseExpressOrderPopup() {
      this.isModalChooseExpressOrderPopup = false
    },
  }
}
</script>

<style scoped>

</style>
